import {
  CompanySettings,
  DEFAULT_COMPANY_SETTINGS,
  DEFAULT_SECURITY_SETTINGS,
  DEFAULT_USER_PREFERENCES,
  SecuritySettings,
  UserPreferences,
} from './user-preferences.model';

const KEY_USER_PREFERENCES = 'user_preferences';
const KEY_SECURITY_SETTINGS = 'security_settings';
const KEY_COMPANY_SETTINGS = 'company_settings';

function readJson<T>(key: string): Partial<T> | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Partial<T>;
  } catch {
    return null;
  }
}

function writeJson<T>(key: string, value: T): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(key, JSON.stringify(value));
}

export function loadUserPreferences(): UserPreferences {
  const saved = readJson<UserPreferences>(KEY_USER_PREFERENCES);
  return { ...DEFAULT_USER_PREFERENCES, ...saved };
}

export function saveUserPreferences(prefs: UserPreferences): void {
  writeJson(KEY_USER_PREFERENCES, prefs);
}

export function loadSecuritySettings(): SecuritySettings {
  const saved = readJson<SecuritySettings>(KEY_SECURITY_SETTINGS);
  return { ...DEFAULT_SECURITY_SETTINGS, ...saved };
}

export function saveSecuritySettings(settings: SecuritySettings): void {
  writeJson(KEY_SECURITY_SETTINGS, settings);
}

export function loadCompanySettings(): CompanySettings {
  const saved = readJson<CompanySettings>(KEY_COMPANY_SETTINGS);
  return { ...DEFAULT_COMPANY_SETTINGS, ...saved };
}

export function saveCompanySettings(settings: CompanySettings): void {
  writeJson(KEY_COMPANY_SETTINGS, settings);
}

export function preferencesEqual(a: UserPreferences, b: UserPreferences): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function securityEqual(a: SecuritySettings, b: SecuritySettings): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function companyEqual(a: CompanySettings, b: CompanySettings): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
